import React from "react";
import PropTypes from "prop-types";
import { Button } from "@xo-union/tk-component-buttons";
import styles from "../../css/index.css";

const FormSubmitButton = _ref => {
  let {
    children,
    disabled,
    isLoading
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, {
    block: true,
    className: styles.formSubButton,
    disabled: disabled,
    isLoading: isLoading,
    type: "submit"
  }, children);
};

process.env.NODE_ENV !== "production" ? FormSubmitButton.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.string,
  isLoading: PropTypes.bool
} : void 0;
FormSubmitButton.defaultProps = {
  children: '',
  disabled: false,
  isLoading: false
};
export default FormSubmitButton;